export default "__VITE_ASSET__aT5jX3Bj__"